import { Link } from "react-router-dom";
import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import { verificationProcess, recentScamReports, safetyChecklist } from "@/mocks/verificationData";

export default function VerificationPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      {/* Page Header */}
      <section className="bg-background-100 border-b border-background-300">
        <div className="max-w-[1000px] mx-auto px-3 md:px-4 py-8 md:py-10">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-primary-400 transition-colors mb-3"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </span>
            홈으로
          </Link>
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 flex items-center justify-center text-primary-500">
              <i className="ri-shield-check-line text-2xl" />
            </span>
            <div>
              <h1 className="text-xl md:text-2xl font-bold text-foreground-700">먹튀검증</h1>
              <p className="text-sm text-foreground-600 mt-0.5">
                철저한 검증 프로세스로 안전한 사이트만을 엄선합니다
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="max-w-[1000px] mx-auto px-3 md:px-4 py-10 md:py-14">
        <h2 className="text-lg md:text-xl font-bold text-foreground-700 text-center mb-8">검증 프로세스</h2>
        <div className="space-y-0">
          {verificationProcess.map((step) => (
            <div key={step.step} className="flex items-start gap-4">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="w-10 h-10 rounded-full bg-primary-500/10 border border-primary-500/30 flex items-center justify-center">
                  <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                    <i className={step.icon} />
                  </span>
                </div>
                {step.step < verificationProcess.length && (
                  <div className="w-0.5 h-12 bg-background-300" />
                )}
              </div>
              <div className="pb-6">
                <h3 className="text-base font-bold text-foreground-700">{step.title}</h3>
                <p className="text-sm text-foreground-600 mt-1 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Recent Reports */}
      <section className="bg-background-100 py-10 md:py-14">
        <div className="max-w-[1000px] mx-auto px-3 md:px-4">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-lg md:text-xl font-bold text-foreground-700">최근 먹튀 제보</h2>
            <span className="text-xs text-foreground-600">총 {recentScamReports.length}건</span>
          </div>
          <div className="bg-background-50 rounded-lg border border-background-300 overflow-hidden">
            <div className="hidden sm:flex items-center gap-4 px-4 py-3 bg-background-200/50 border-b border-background-300 text-[11px] font-bold text-foreground-600">
              <span className="flex-1">사이트명</span>
              <span className="w-32">도메인</span>
              <span className="w-24">문제 유형</span>
              <span className="w-20">신고일</span>
              <span className="w-20">상태</span>
            </div>
            {recentScamReports.map((report) => (
              <div
                key={report.id}
                className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 px-4 py-3 border-b border-background-300/50 last:border-0 text-xs"
              >
                <span className="flex-1 font-bold text-foreground-700">{report.siteName}</span>
                <span className="sm:w-32 text-foreground-600">{report.domain}</span>
                <span className="sm:w-24">
                  <span className="inline-block px-1.5 py-0.5 text-[10px] bg-red-500/10 text-red-400 rounded">
                    {report.issue}
                  </span>
                </span>
                <span className="sm:w-20 text-foreground-600">{report.reportDate}</span>
                <span className="sm:w-20">
                  <span
                    className={`inline-block px-1.5 py-0.5 text-[10px] rounded ${
                      report.status === "확인완료"
                        ? "bg-accent-500/10 text-accent-500"
                        : "bg-secondary-500/10 text-secondary-400"
                    }`}
                  >
                    {report.status}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Safety Checklist */}
      <section className="max-w-[860px] mx-auto px-3 md:px-4 py-10 md:py-14">
        <h2 className="text-lg md:text-xl font-bold text-foreground-700 text-center mb-8">
          사이트 이용 전 안전 체크리스트
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {safetyChecklist.map((item, i) => (
            <div key={i} className="flex items-center gap-3 bg-background-100 rounded-lg border border-background-300 p-4">
              <span className="w-6 h-6 rounded-full bg-primary-500/10 flex items-center justify-center flex-shrink-0">
                <span className="w-3.5 h-3.5 flex items-center justify-center text-primary-500">
                  <i className="ri-check-line" />
                </span>
              </span>
              <span className="text-sm text-foreground-600">{item}</span>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link
            to="/support"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-foreground-50 text-sm font-bold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-alert-line" />
            </span>
            먹튀 제보하기
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}